<template>
  <div
    id="wallet-form-header"
    class="text-center"
  >
    <h2
      v-if="title"
      id="wallet-form-title"
      class="primary--text font-weight-bold"
      v-html="title"
    />
    <p
      v-if="message"
      id="wallet-form-message"
      class="font-weight-bold my-4"
      v-html="message"
    />
  </div>
</template>

<script>
export default {
  name: 'WalletFormHeader',
  props: {
    title: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    }
  }
}
</script>
